import { createFileRoute } from '@tanstack/react-router'

// A job with no report open: level 1, the people list the section renders.
export const Route = createFileRoute('/_app/dev-resources/transitions/jobs/$jobId/')({})
